export function CamelCaseToFirstUpper(word) {
  // Split the word by camel case pattern and replace with space
  if (word) {
    const formattedWord = word.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Capitalize the first letter of the formatted word
    const capitalizedWord =
      formattedWord.charAt(0).toUpperCase() + formattedWord.slice(1);

    return capitalizedWord;
  }
  return;
}

export function capitalizeFirstLetterOfEachWord(sentence) {
  if (sentence) {
    const words = sentence.split(" ");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return capitalizedWords.join(" ");
  }
  return;
}
export function toTitleCase(sentence = "") {
  return sentence
    .trim()
    .replace(/\s+/g, " ")
    .toLowerCase()
    .replace(/\b[a-z]/g, (c) => c.toUpperCase());
}
export function capitalizeFirstLetterOfWordAndSmallOthers(sentence) {
  if (sentence) {
    const words = sentence.split(" ");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    );
    return capitalizedWords.join(" ");
  }
  return;
}

export const getId = (str) => {
  if (typeof str == "string" && str?.includes("/")) {
    const parts = str.split("/");
    const lastPart = parts[parts.length - 1];
    return parseInt(lastPart, 10);
  }
};

export function generateUniqueFilename(file) {
  const timestamp = Date.now();
  const randomString = Math.random().toString(36).substring(2, 15);
  const extension = file.name.split(".").pop();
  return `${timestamp}_${randomString}.${extension}`;
}

export const getQuotationFor = (data) => {
  let bag = "";

  if (data?.quotationType === "fanpad") {
    bag += "Fanpad";
  } else if (data?.quotationType === "nvph") {
    bag += "Nvph";
  } else if (data?.quotationType === "nethouse") {
    bag += "Nethouse";
  } else if (data?.quotationType === "soilbasedfanpad") {
    bag += "Fanpad Soil Based Precision Farming";
  } else if (data?.quotationType === "soilbasednvph") {
    bag += "Nvph Soil Based Precision Farming";
  } else if (data?.quotationType === "soilbasednethouse") {
    bag += "Nethouse Soil Based Precision Farming";
  } else if (data?.quotationType === "fanpad with hydroponics") {
    bag += "Fanpad";
    let next = "";
    if (data?.a_FramePercent > 0) {
      next += ` + ${data?.a_FramePercent}% A-Frame`;
    }
    if (data?.flatBedPercent > 0) {
      next += ` + (${data?.flatBedPercent}%) Flat-NFT`;
    }
    if (data?.growBagPercent > 0 && data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growslab`;
    }
    if (data?.growBagPercent > 0 && !data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growbag`;
    }
    if (data?.dutchBucketPercent > 0) {
      next += `+ (${data?.dutchBucketPercent}%) Dutchbucket`;
    }
    bag += ` ${next}`;
  } else if (data?.quotationType === "nethouse with hydroponics") {
    bag += "Nethouse";
    let next = "";
    if (data?.a_FramePercent > 0) {
      next += ` + (${data?.a_FramePercent}%) A-Frame`;
    }
    if (data?.flatBedPercent > 0) {
      next += ` + (${data?.flatBedPercent}%) Flat-NFT`;
    }
    if (data?.growBagPercent > 0 && data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growslab`;
    }
    if (data?.growBagPercent > 0 && !data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growbag`;
    }
    if (data?.dutchBucketPercent > 0) {
      next += ` + (${data?.dutchBucketPercent}%) Dutchbucket`;
    }
    bag += ` ${next}`;
  } else if (data?.quotationType === "nvph with hydroponics") {
    bag += "Nvph";
    let next = "";
    if (data?.a_FramePercent > 0) {
      next += ` + (${data?.a_FramePercent}%) A-Frame`;
    }
    if (data?.flatBedPercent > 0) {
      next += ` + (${data?.flatBedPercent}%) Flat-NFT`;
    }
    if (data?.growBagPercent > 0 && data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growslab`;
    }
    if (data?.growBagPercent > 0 && !data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growbag`;
    }
    if (data?.dutchBucketPercent > 0) {
      next += ` + (${data?.dutchBucketPercent}%) Dutchbucket`;
    }
    bag += ` ${next}`;
  } else if (data?.quotationType === "hydroponics only") {
    bag += "Without-Cea";
    let next = "";
    if (data?.a_FramePercent > 0) {
      next += ` + (${data?.a_FramePercent}%) A-Frame`;
    }
    if (data?.flatBedPercent > 0) {
      next += ` + (${data?.flatBedPercent}%) Flat-NFT`;
    }
    if (data?.growBagPercent > 0 && data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growslab`;
    }
    if (data?.growBagPercent > 0 && !data?.isGrowSlab) {
      next += ` + (${data?.growBagPercent}%) Growbag`;
    }
    if (data?.dutchBucketPercent > 0) {
      next += ` + (${data?.dutchBucketPercent}%) Dutchbucket`;
    }
    bag += ` ${next}`;
  }

  return bag;
};
